// 导入组件
import Vue from 'vue';
import Router from 'vue-router';
// 登录
import login from '@/views/login';
// Dashboard
import index from '@/views/index';
import Dashboard from '@/views/home/index';

//短信
import SMS from '@/views/sms/sms';

//CONFIGURATION
//SIM card
import card_list from '@/views/card/card_list';
//Cardholder
import opencard_list from '@/views/opencard/opencard_list';
//Operator
import operator_list from '@/views/operator/operator_list';
import super_agent_list from '@/views/operator/super_agent_list';
//Business
import business_list from '@/views/business/business_list';
//Business settlement
import business_settlement from '@/views/business_settlement/business_settlement';
//Business
import country from '@/views/country/country';

//交易
import Transactions from '@/views/transaction/reserved';
// import reserved from '@/views/transaction/reserved';
// import reserved_backups from '@/views/transaction/reserved_backups';
import Transfers from '@/views/transaction/transfers';
// import transaction_backups from '@/views/transaction/transaction_backups';
// import transaction_dustbin from '@/views/transaction/transaction_dustbin';


//APP
import automatic_app_list from '@/views/automatic_app/automatic_app_list';
import app_user from '@/views/sms/app_user';

//Setting
import setting from '@/views/system/setting';
// 启用路由
Vue.use(Router);

// 导出路由 
export default new Router({
  routes: [{
    path: '/',
    name: '',
    component: login,
    hidden: true,
  },
  {
    path: '/login',
    name: 'login',
    component: login,
    hidden: true,
  }, {
    path: '/index',
    name: 'Dashboard',
    component: index,
    iconCls: 'el-icon-tickets',
    children: [{
      path: '/home/index',
      name: 'Dashboard',
      component: Dashboard,
    }, {
      path: '/sms/sms',
      name: 'SMS',
      component: SMS,
    },
    {
      path: '/card/card_list',
      name: 'SIM Card',
      component: card_list,
    }, {
      path: '/opencard/opencard_list',
      name: 'Card Holder',
      component: opencard_list,
    }, {
      path: '/operator/operator_list',
      name: 'Operator',
      component: operator_list,
    }, {
      path: '/operator/super_agent_list',
      name: 'Super Agent',
      component: super_agent_list,
    },
    {
      path: '/business/business_list',
      name: 'Business',
      component: business_list,
    },
    {
      path: '/business_settlement/business_settlement',
      name: 'Business settlement',
      component: business_settlement,
    },
    {
      path: '/country/country',
      name: 'Country',
      component: country,
    },
    {
      path: '/transaction/reserved',
      name: 'Transactions',
      component: Transactions,
    }, {
      path: '/transaction/transfers',
      name: 'Transfers',
      component: Transfers,
    },
    {
      path: '/sms/app_user',
      name: 'APP Users',
      component: app_user,
    },
    {
      path: '/automatic_app/automatic_app_list',
      name: 'Automatic',
      component: automatic_app_list,
    },
    {
      path: '/system/setting',
      name: 'Setting',
      component: setting,
    }
    ]
  }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js